import ProtectionPlans from './ProtectionPlans';

export default ProtectionPlans;
